export default {"src":"/_next/static/media/0x39aa39c021dfbae8fac545936693ac917d5e7563.9f02cdc6.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};